// src/api/groups.ts

import { apiClient } from './client';
import { Group, ApiResponse, CreateGroupDto } from '../types';

export const groupsApi = {
    // Получить все группы
    getAll: async (): Promise<ApiResponse<Group[]>> => {
        return apiClient.get<Group[]>('/groups');
    },

    // Получить группу по ID
    getById: async (id: number): Promise<ApiResponse<Group>> => {
        return apiClient.get<Group>(`/groups/${id}`);
    },

    // Создать новую группу
    create: async (data: CreateGroupDto): Promise<ApiResponse<Group>> => {
        return apiClient.post<Group>('/groups', data);
    },

    // Обновить группу
    update: async (id: number, data: Partial<CreateGroupDto>): Promise<ApiResponse<Group>> => {
        return apiClient.put<Group>(`/groups/${id}`, data);
    },

    // Удалить группу
    delete: async (id: number, isNeedRemoveLessons?: boolean): Promise<ApiResponse<void>> => {
        const url = isNeedRemoveLessons
            ? `/groups/${id}?isNeedRemoveLessons=true`
            : `/groups/${id}`;
        return apiClient.delete<void>(url);
    },

    // Добавить ученика в группу
    addStudent: async (groupId: number, studentId: number): Promise<ApiResponse<Group>> => {
        return apiClient.post<Group>(`/groups/${groupId}/students`, { studentId });
    },

    // Удалить ученика из группы
    removeStudent: async (groupId: number, studentId: number): Promise<ApiResponse<Group>> => {
        return apiClient.delete<Group>(`/groups/${groupId}/students/${studentId}`);
    },
};